// Libs
import React from 'react'
import PropTypes from 'prop-types'

// Styles
import {
  cellStyle,
} from './styles'

// Exports
export const TableCell = ({children, width, align = 'left'}) => (
  <div style={{
    ...cellStyle,
    justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
    flex: `0 0 ${width}%`,
  }}>
    <div style={{padding: '0 5px'}}>
      {children}
    </div>
  </div>
)

TableCell.propTypes = {
  width: PropTypes.number.isRequired,
  children: PropTypes.node,
  align: PropTypes.oneOf(['left', 'right', 'center']),
}

export default TableCell
